<mat-card>
  <mat-card-title>
    {{ ("uploadDossier" | i18n) || "Dossier Hochladen" }}
  </mat-card-title>
  <mat-card-content>
    <ng-container *ngIf="loggedInUserWithCustomer">
      <ng-container>
        <app-upload-file
          *ngIf="
            (isNewUser && !temporaryFiles.length) ||
            (!isNewUser && !customerInformation?.files?.length)
          "
          [isUploading]="isUploading"
          (inputEvent)="uploadFile($event)"></app-upload-file>

        <div
          *ngIf="
            isNewUser && !isUploading && !isDownloading && temporaryFiles.length
          ">
          <ng-container>
            <div class="profile-edit__file-list">
              <div
                class="profile-edit__file-list-item"
                *ngFor="let file of temporaryFiles">
                <button
                  type="button"
                  mat-button
                  (click)="downloadFile($event, file)">
                  <mat-icon svgIcon="download"></mat-icon>
                  <span>{{ file.fileName }} </span>

                  <mat-icon
                    *ngIf="progressbarValue === 100"
                    class="color-success mat-button-small-icon"
                    svgIcon="check-circle"></mat-icon>
                </button>
                <small
                  >{{ $any(file.size) / (1024 * 1024) | number: "1.0-3" }} MB /
                  {{ file.updatedAt | date: "short" }}
                </small>
                <button
                  mat-button
                  class="profile-edit__file-list-item__delete-button"
                  (click)="removeFileDialog(file, deleteConfirm)">
                  <mat-icon svgIcon="close"></mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <div
          *ngIf="
            !isNewUser &&
            !isUploading &&
            !isDownloading &&
            customerInformation?.files?.length
          ">
          <ng-container>
            <div
              class="profile-edit__file-list"
              *ngIf="customerInformation?.files?.length">
              <div
                class="profile-edit__file-list-item"
                *ngFor="let file of customerInformation!.files">
                <button
                  type="button"
                  mat-button
                  (click)="downloadFile($event, file)">
                  <mat-icon svgIcon="download"></mat-icon>
                  <span>{{ file.fileName }} </span>

                  <mat-icon
                    *ngIf="progressbarValue === 100"
                    class="color-success mat-button-small-icon"
                    svgIcon="check-circle"></mat-icon>
                </button>
                <small
                  >{{ $any(file.size) / (1024 * 1024) | number: "1.0-3" }} MB /
                  {{ file.timestamp | date: "short" }}
                </small>
                <button
                  mat-button
                  class="profile-edit__file-list-item__delete-button"
                  (click)="removeFileDialog(file, deleteConfirm)">
                  <mat-icon svgIcon="close"></mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
        <mat-progress-bar
          *ngIf="isDownloading"
          mode="determinate"
          [value]="progressbarValue"></mat-progress-bar>
      </ng-container>
    </ng-container>
  </mat-card-content>
</mat-card>

<ng-template #deleteConfirm>
  <h2 mat-dialog-title>
    {{ ("deleteConfirmTitle" | i18n) || "Remove this document?" }}
  </h2>
  <mat-dialog-content>
    {{
      ("deleteConfirmContent" | i18n) ||
        "This will delete this document and cannot be undone"
    }}
    <br /><br />
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-flat-button
      mat-dialog-close>
      {{ ("cancel" | i18n) || "cancel" | titlecase }}
    </button>
    <button
      mat-flat-button
      color="warn"
      [mat-dialog-close]="true">
      {{ ("remove" | i18n) || "remove" | titlecase }}
    </button>
  </mat-dialog-actions>
</ng-template>
